export class Region {
    public Code: string;
    public Description: string;
    public Comunas: Comuna[];
}

export class Comuna {
    public Code: string;
    public Description: string;
}


